import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import InsurerLandingDefault from '@/views/InsurerLandingDefault.vue';
import ResponseGroupView from '@/views/ResponseGroupView.vue';
import Branch from '@/components/Branch.vue';
import ComparisonView from '@/components/ComparisonView.vue';
import DetailsView from '@/components/DetailsView.vue';
import OrderView from '@/components/OrderView.vue';
import store from '@/store';
import {AxiosResponse} from 'axios';
import {api} from '@/Api';
import {ResponseGroup} from '@/lib/ResponseGroup';
import Login from '@/views/Login.vue';
import RgFetcher from '@/components/RgFetcher.vue';

Vue.use(Router);




export default new Router(
  {
    mode: 'history',
    base: process.env.BASE_URL,
    // base: '/',
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
      },
      {
        path: '/fetcher',
        name: 'fetcher',
        component: RgFetcher,
      },
      {

        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/cotation/:branchSlug/questionnaire/:id/:entity?/:hash?',
        name: 'questionnaire',
        props: true,
        component: ResponseGroupView,
      },
      {
        path: '/resultats-de-comparaison/:responseGroupId',
        name: 'comparisonResult',
        component: ComparisonView,
        beforeEnter: (to, from, next) => {
          store.commit('loading');
          if (store.state.currentResponseGroup !== null) {
            next();
            store.commit('loaded');
          } else {
            ResponseGroup.load(to.params.responseGroupId).then(() => {
              next();
              store.commit('loaded');
            });
          }
        },
      },
      {
        path: '/souscription/:order',
        name: 'order',
        component: OrderView,
        beforeEnter: (to, from, next) => {
          store.commit('loading');
          if (store.state.order === null) {
            api.getOrder(parseInt(to.params.order)).then((response: AxiosResponse) => {
              store.commit('setOrder', response.data.data);
              next();
              store.commit('loaded');
            });
          } else {
            next();
            store.commit('loaded');
          }
        },
      },
    ],
  });
